import { useErrorContext } from "../../global/hooks/useErrorContext";
import { IIndividualLearningPlan } from "../types/interfaces/IIndividualLearningPlan";
import { IlpData } from "../types/classes/IlpData";

//This custom hook is responsible for making a POST request to the create a learning plan api endpoint.
export default function useCreateIlp(apiCreateIlp: string): ((requestBody: IlpData<string>) => Promise<IIndividualLearningPlan[]>) {
    const { setError } = useErrorContext();

    const INELIGIBLE_ERROR_TEXT: string | null = process.env.REACT_APP_ILP_INELIGIBLE_ERROR_TEXT ?? null;

    const handleError = (message: string | null, statusCode: number) => {  
        setError({ message, statusCode });
        return [];
    };

    const createIlpFetch = async (requestBody: IlpData<string>): Promise<IIndividualLearningPlan[]> => {
        try {
            const response = await fetch(apiCreateIlp, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify(requestBody)
            });
            if (!response.ok) {
                console.log('create', response.statusText);
                if (response.status === 401 || response.status === 403) {
                    return handleError(INELIGIBLE_ERROR_TEXT, -response.status);
                } else {
                    return handleError(null, -1);
                }
            }
            const result = await response.json();
            if (!result) {
                return handleError(null, -2);
            } else {
                if (result.CustomerKey === null || result.Data === null || (!result.Succeeded && result.Errors !== null)) {
                    return handleError(null, -3);
                }

                if (result.Data && (result.Data[0].LearnerInfo === null || result.Data[0].LearnerInfo.CustomerKey === null)) {
                    return handleError(null, -4);
                }
            }
            return result.Data;
        } catch (error: any) {
            console.log('create error', error);
            return handleError(null, -error.status);
        }
    };

    return async (requestBody: IlpData<string>) => {
        return createIlpFetch(requestBody);
    };
}